import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import uri from "../../../constants/uri";

const deleteAddresses = async (binds) => {
	try {
		await Promise.all(
			binds.map((bind) => {
				client.delete(`${uri}/bind/${bind.id}`, {
					headers: authHeader(),
				});
			})
		);
	} catch (e) {
		console.error(e);
		message.error("Не получилось удалить адреса, попробуйте позже");
	}
};

export default deleteAddresses;
